export const links = {
	productGuide: 'https://intract.gitbook.io/product-guide',
	docs: {
		campaigns: 'https://intract.gitbook.io/product-guide/product-guides/quests',
		loyalty:
			'https://intract.gitbook.io/product-guide/product-guides/loyalty-program',
		events: 'https://intract.gitbook.io/product-guide/product-guides/events',
		taskAPIs: 'https://intract.gitbook.io/product-guide/tools/integrate-apis',
		dave: 'https://intract.gitbook.io/product-guide/tools/dave-no-code-task-verification',
		nfts: 'https://intract.gitbook.io/product-guide/tools/nft-rewards',
		tokenApproval:
			'https://intract.gitbook.io/product-guide/product-guides/quests/launching-your-quests/setting-up-rewards/adding-custom-token-as-rewards',
		updatingTasks: 'https://docs.intract.io',
		rewards:
			'https://intract.gitbook.io/product-guide/product-guides/quests/launching-your-quests/setting-up-rewards',
		addingContract:
			'https://intract.gitbook.io/product-guide/tools/dave-no-code-task-verification/understanding-and-creating-actions',
		needHelpAddingContract:
			'https://intract.gitbook.io/product-guide/tools/dave-no-code-task-verification/understanding-and-creating-actions',
		apiCreation:
			'https://www.notion.so/intract-io/Create-your-OWN-API-based-template-3cf655ee00e34d27bd230f1fa6deee1e?pvs=4',
		exports:
			'https://intract.gitbook.io/product-guide/getting-started/manage-your-team#data-exports',
		discordIntegration:
			'https://intract.gitbook.io/product-guide/tools/integrations/discord',
		telegramIntegration:
			'https://intract.gitbook.io/product-guide/tools/integrations/telegram',
		kols: 'https://intract.gitbook.io/product-guide/product-guides/kols-marketplace',
		projectsPartnerships:
			'https://intract.gitbook.io/product-guide/product-guides/partnerships',
		rewardStore:
			'https://intract.gitbook.io/product-guide/product-guides/reward-store',
		apiTokensDocs:
			'https://docs.intract.io/v/product-guide/tools/integrate-apis/api-tokens',
		apiDocs:
			'https://documenter.getpostman.com/view/25023496/2sA3dsmZUS#c7be9dbb-2e56-46b9-85a4-fcc3d5183822',
		bestPractices:
			'https://intract-io.notion.site/ca4169e8abff4593b4ab9a55d3118518?v=dc26da0e25b64e23a4ae602bfc327365',
	},
	telegram: 'https://t.me/Venky3456',
	TOS: 'https://intract.gitbook.io/website-policies/intract-terms-of-use',
	privacyPolicy:
		'https://intract.gitbook.io/website-policies/intract-privacy-policy',
	generalDisclaimer:
		'https://intract.gitbook.io/website-policies/general-disclaimers',
	featureRequest: 'https://intract-dashboard.canny.io/feature-requests',
	kolProfile: 'https://t.me/AbbyS_web3',
};
